import {
  FETCH_SERVICE_FAILURE,FETCH_SERVICE_SUCCESS
} from "../actionTypes";

const initialState = {
  service: [],
  error: null,
  message: null,
  totalPages: 1,
  totalRecords : 0,
  currentPage: 1,
};

export const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SERVICE_SUCCESS:
      return {
         ...state,
        service: action.payload.service,
        message: action.payload.message,
        totalPages:action.payload.totalPages,
        currentPage: action.payload.currentPage,
        totalRecords:action.payload.totalRecords,
     };

    case FETCH_SERVICE_FAILURE:
      return { 
        ...state,
        error: action.payload,
        message:null,
        totalPages: 1,
        totalRecords : 0,
        currentPage: 1,
    };

    default:
      return state;
  }
};
